export enum SitecoreReportTypeEnum {
  Individual = 'individual',
  Club = 'club',
  District = 'district',
  Region = 'region',
  Grants = 'grants',
}

export enum SitecoreResourceTypeEnum {
  Club = 'club',
  District = 'district',
}
